import React, { FC } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { ILoad, ITodo } from 'apps/fleet-planner/types'

export enum TODO_FIELDS {
  tractorVin = 'Tractor VIN',
  driver = 'driver',
  truck = 'truck',
}

interface ITodosInlineMessageProps {
  load: ILoad
  onClick: (name?: string, elementId?: string) => void
  currentShipmentTodos?: ITodo
}

export const TodosInlineMessage: FC<ITodosInlineMessageProps> = ({
  currentShipmentTodos,
  load,
  onClick,
}) => {
  const { missingDriver, missingTruckNumber, missingVin } = currentShipmentTodos || {}
  const { shipmentDetails } = useMarketplaceContext()
  const { info } = shipmentDetails || {}
  const { drivers, truck } = load || {}

  // construct an array depending on which fields are missing to help with string parsing
  const todos: TODO_FIELDS[] = []
  if (missingDriver && (!drivers || !drivers?.length)) todos.push(TODO_FIELDS.driver)
  if (missingTruckNumber && !truck?.truckNumber) todos.push(TODO_FIELDS.truck)
  if (missingVin && (!info || !info.vin)) todos.push(TODO_FIELDS.tractorVin)

  const isSingleField = todos.length === 1

  // NOTE: clickHandler() is only clickable if there is 1 field missing
  const clickHandler = () => {
    onClick('load-assignment', '.load-assignment')
  }

  const getMessage = () => {
    const todosLength = todos.length
    if (!todosLength) return ''

    const missingFields =
      todosLength === 2 ? `${todos.join(' and ')}.` : 'driver, truck, and Tractor VIN. '
    const message = `This load is missing a ${missingFields}`

    return (
      <div>
        <span className='b'>{message}</span> Please add these details below.
      </div>
    )
  }

  const getSingleFieldMessage = () => {
    const [missingField] = todos || []
    switch (missingField) {
      case TODO_FIELDS.tractorVin:
        return (
          <div>
            <span className='b'>This load requires a Tractor VIN. </span>
            <Button variant='text' noPadding onClick={clickHandler}>
              Add a Tractor VIN
            </Button>
          </div>
        )
      case TODO_FIELDS.driver:
        return (
          <div>
            <span className='b'>This load is missing a driver. </span>
            <Button variant='text' noPadding onClick={clickHandler}>
              Assign a driver
            </Button>
          </div>
        )
      case TODO_FIELDS.truck:
        return (
          <div>
            <span className='b'>This load requires a Truck number. </span>
            <Button variant='text' noPadding onClick={clickHandler}>
              Add Truck
            </Button>
          </div>
        )
      default:
        return <></>
    }
  }

  return todos.length ? (
    <InlineMessage
      message={isSingleField ? getSingleFieldMessage() : getMessage()}
      type={INLINE_MESSAGE_VARIANTS.WARNING}
    />
  ) : (
    <></>
  )
}
